function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "325.9,139.1 325.8,139 325.8,139  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M55.8,109.5L55.8,109.5c-4.4-3.3-5.4-9.5-2.1-14L112,16.7c3.3-4.4,9.5-5.4,14-2.1l0,0c4.4,3.3,5.4,9.5,2.1,14                 l-58.3,78.8C66.5,111.9,60.2,112.8,55.8,109.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M361.6,164.2c-3.9-3.9-10.2-3.9-14.1,0l-7.3,7.3c-4.1,4.1-10.7,4.2-14.9,0.2c-2.3-2.1-3.4-5-3.4-7.8                 c0-2.7,1-5.5,3.1-7.6l27-27c2-2,2.9-4.5,2.9-7.1c0-2.6-1-5.1-2.9-7.1c-3.9-3.9-10.2-3.9-14.2,0l-24.4,24.4                 c-7.4,7.4-19.4,7.6-27,0.5l-0.1-0.1l0,0l16.7-17.8c1.8-1.9,2.7-4.4,2.7-6.8c0-2.7-1.1-5.3-3.2-7.3c-4-3.8-10.4-3.6-14.1,0.5                 l-2.1,2.3c-3.5,3.7-9.3,3.9-13.1,0.4l-0.8-0.7v0c-1.9-1.8-2.9-4.3-2.9-6.7c0-2.4,0.9-4.7,2.7-6.5l4-4c2-2,2.9-4.5,2.9-7.1                 s-1-5.1-2.9-7.1c-3.9-3.9-10.2-3.9-14.1,0l-4,4h-67.6c-6.8,0-10.2-8.2-5.4-13c1-1,1.7-2.1,2.2-3.3c0.5-1.2,0.7-2.5,0.7-3.8                 c0-2.6-1-5.1-2.9-7.1c-3.9-3.9-10.2-3.9-14.1,0l-24.4,24.4c-1.7,1.7-4,2.7-6.4,2.7c-5.5,0-9.1-4.5-9.1-9.2c0-2.2,0.8-4.5,2.7-6.4                 l3.6-3.6c2-2,2.9-4.5,2.9-7.1s-1-5.1-2.9-7.1c-3.9-3.9-10.2-3.9-14.1,0L12.9,198.5l117.3-1.1v-3.3h2.7v3.3l13.6,0l20.5,0l12,0v-3.2                 h2.7v3.2l38.6,0l12.2-0.1l41-0.4l9.3-0.1l-0.5-0.4c0.4-0.1,0.9-0.2,1.3-0.3l-0.7,0.7l29.8-0.3h30.6l0.2-0.2l17.8-17.8                 c2-2,2.9-4.5,2.9-7.1C364.5,168.8,363.5,166.2,361.6,164.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M271.3,182.9H110.4c-3.1,0-5.7-2.5-5.7-5.7V71.3c0-3.1,2.5-5.7,5.7-5.7h160.9c3.1,0,5.7,2.5,5.7,5.7v105.9                 C277,180.4,274.4,182.9,271.3,182.9z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 349.5,
  cy: 95.2,
  r: 10.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 212.1,
  cy: 38,
  r: 4.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st3",
  cx: 78,
  cy: 166.4,
  r: 4.5
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M270.3,180.3h-159c-2.1,0-3.7-1.7-3.7-3.7v-5.9h166.5v5.9C274.1,178.6,272.4,180.3,270.3,180.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M271.3,182.9H110.4c-3.1,0-5.7-2.5-5.7-5.7V71.3c0-3.1,2.5-5.7,5.7-5.7h160.9c3.1,0,5.7,2.5,5.7,5.7v105.9                 C277,180.4,274.4,182.9,271.3,182.9z"
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 107.8,
  y1: 167.8,
  x2: 274.2,
  y2: 167.8
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 167.1,
  y: 196.5,
  className: "st6",
  width: 46.2,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 45,
  y: 196.5,
  className: "st6",
  width: 119.4,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 216,
  y: 196.5,
  className: "st6",
  width: 91.8,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 310.7,
  y: 196.5,
  className: "st6",
  width: 15.7,
  height: 2
})), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 124.2,
  y1: 109.3,
  x2: 163.2,
  y2: 109.3
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 124.2,
  y1: 100,
  x2: 171.2,
  y2: 100
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 130.6,
  y1: 90.3,
  x2: 171.2,
  y2: 90.3
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 123.9,
  y1: 90.3,
  x2: 126.5,
  y2: 90.3
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 180.7,
  y1: 185.4,
  x2: 180.7,
  y2: 197.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 201.2,
  y1: 185.4,
  x2: 201.2,
  y2: 197.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 252.9,
  y1: 174.5,
  x2: 263.6,
  y2: 174.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 266.6,
  y1: 174.5,
  x2: 270.3,
  y2: 174.5
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 266.8,
  cy: 78,
  r: 32.8
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M266.8,111.7c-18.6,0-33.8-15.1-33.8-33.8s15.1-33.8,33.8-33.8s33.8,15.1,33.8,33.8S285.4,111.7,266.8,111.7z                    M266.8,46.2C249.3,46.2,235,60.5,235,78c0,17.5,14.3,31.8,31.8,31.8s31.8-14.3,31.8-31.8C298.6,60.5,284.3,46.2,266.8,46.2z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 91.4,
  y1: 37.9,
  x2: 79.1,
  y2: 50.2
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 79.1,
  y1: 37.9,
  x2: 91.4,
  y2: 50.2
})), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 85.2,
  cy: 44.1,
  r: 3.9
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 352.3,
  y: 115.4,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 23.614 289.8285)",
  className: "st6",
  width: 18.7,
  height: 2
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 360.7,
  y: 107.1,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 23.6108 289.8223)",
  className: "st6",
  width: 2,
  height: 18.7
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 361.7,
  cy: 116.4,
  r: 3
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M361.7,120.4c-1.1,0-2.1-0.4-2.8-1.2c-1.6-1.6-1.6-4.1,0-5.7s4.1-1.6,5.7,0s1.6,4.1,0,5.7                   C363.7,120,362.7,120.4,361.7,120.4z M361.7,114.4c-0.5,0-1,0.2-1.4,0.6c-0.8,0.8-0.8,2.1,0,2.9c0.8,0.8,2.1,0.8,2.9,0l0,0                   c0.8-0.8,0.8-2.1,0-2.9C362.7,114.6,362.2,114.4,361.7,114.4z"
})), /*#__PURE__*/React.createElement("circle", {
  className: "st5",
  cx: 212.1,
  cy: 38,
  r: 4.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st5",
  cx: 78,
  cy: 166.4,
  r: 6.1
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st5",
  points: "301.6,28.1 303.3,31.4 306.9,32 304.3,34.6 304.9,38.2 301.6,36.5 298.3,38.2 298.9,34.6 296.3,32                  299.9,31.4  "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 266.8,
  cy: 78,
  r: 28.7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 266.8,
  y1: 64,
  x2: 266.8,
  y2: 86.8
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st5",
  points: "276.5,77.1 266.8,86.8 257.1,77.1      "
})), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 257.1,
  y1: 90.9,
  x2: 276.5,
  y2: 90.9
})), /*#__PURE__*/React.createElement("rect", {
  x: 182.5,
  y: 185.5,
  className: "st4",
  width: 16.8,
  height: 10.1
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 289.4,
  y1: 123.1,
  x2: 289.4,
  y2: 146.9
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 301.6,
  y1: 139.1,
  x2: 301.6,
  y2: 153.9
}));

var SvgMsiDownload = function SvgMsiDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 376.9 210.4",
    style: {
      enableBackground: "new 0 0 376.9 210.4"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMsiDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/msi_download.55b282e7.svg";
export { ForwardRef as ReactComponent };